<div class="add-existing-product-dialog">
  <h2 mat-dialog-title>{{ 'products.addExistingProductDialogTitle' | translate }}</h2>

  <mat-dialog-content>
    <p class="hint">{{ 'products.addExistingProductHint' | translate }}</p>

    <mat-form-field appearance="outline" class="search-field">
      <mat-label>{{ 'searchProducts' | translate }}</mat-label>
      <input matInput [formControl]="searchControl" autocomplete="off">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <div *ngIf="isLoading" class="loading">
      <mat-spinner diameter="32"></mat-spinner>
    </div>

    <mat-table [dataSource]="products" *ngIf="!isLoading" class="products-table">
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            [checked]="isAllSelected()"
            [indeterminate]="isIndeterminate()"
            (change)="toggleAll()">
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-checkbox
            [checked]="selection.isSelected(row.prdID)"
            (change)="selection.toggle(row.prdID)"
            (click)="$event.stopPropagation()">
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="prdCode">
        <mat-header-cell *matHeaderCellDef>{{ 'form.product.sku' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.prdCode }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="prdNameEn">
        <mat-header-cell *matHeaderCellDef>{{ 'form.product.name' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.prdNameEn }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="prdCategory">
        <mat-header-cell *matHeaderCellDef>{{ 'form.product.category' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.prdCategoryName || '-' }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"
               (click)="selection.toggle(row.prdID)"
               class="row-clickable"></mat-row>
    </mat-table>

    <div *ngIf="!isLoading && products.length === 0" class="empty-state">
      {{ 'noResults' | translate }}
    </div>

    <div class="storage-target">
      <button mat-stroked-button color="primary" (click)="openStoragePicker()">
        <mat-icon>inventory_2</mat-icon>
        {{ 'products.chooseStorageOptional' | translate }}
      </button>
      <span class="storage-target__value" *ngIf="selectedStorages.length > 0">
        {{ selectedStorageLabel }}
        <button mat-icon-button (click)="clearStorages()" [attr.aria-label]="'cancel' | translate">
          <mat-icon>close</mat-icon>
        </button>
      </span>
      <span class="storage-target__hint" *ngIf="selectedStorages.length === 0">
        {{ 'products.noStorageSelectedHint' | translate }}
      </span>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="isSubmitting">
      {{ 'cancel' | translate }}
    </button>
    <button mat-raised-button color="primary"
            (click)="onSubmit()"
            [disabled]="!selection.hasValue() || isSubmitting">
      <mat-spinner diameter="18" *ngIf="isSubmitting"></mat-spinner>
      <span *ngIf="!isSubmitting">
        {{ 'products.addToThisLocation' | translate }}
        <span *ngIf="selection.hasValue()">({{ selection.selected.length }})</span>
      </span>
    </button>
  </mat-dialog-actions>
</div>
